﻿package com.mgacreative.hotelru.feature.admin.ui

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.mgacreative.hotelru.domain.model.Department
import com.mgacreative.hotelru.domain.repository.DepartmentRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

class AdminDepartmentViewModel(
    private val departmentRepository: DepartmentRepository
) : ViewModel() {

    private val _departments = MutableStateFlow<List<Department>>(emptyList())
    val departments: StateFlow<List<Department>> = _departments.asStateFlow()

    private val _isLoading = MutableStateFlow(false)
    val isLoading: StateFlow<Boolean> = _isLoading.asStateFlow()

    private val _error = MutableStateFlow<String?>(null)
    val error: StateFlow<String?> = _error.asStateFlow()

    fun loadDepartments() {
        viewModelScope.launch {
            _isLoading.value = true
            _error.value = null
            try {
                departmentRepository.getDepartments().collect { deps ->
                    _departments.value = deps
                    _isLoading.value = false
                }
            } catch (e: Exception) {
                _error.value = e.message ?: "Bilinmeyen bir hata oluştu"
                _isLoading.value = false
            }
        }
    }

    fun addDepartment(name: String, permissions: List<String>) {
        viewModelScope.launch {
            _isLoading.value = true
            val result = departmentRepository.addDepartment(name, permissions)
            if (result.isFailure) {
                _error.value = result.exceptionOrNull()?.message ?: "Departman eklenemedi"
            } else {
                loadDepartments()
            }
            _isLoading.value = false
        }
    }

    fun updateDepartment(id: String, name: String, permissions: List<String>) {
        viewModelScope.launch {
            _isLoading.value = true
            val result = departmentRepository.updateDepartment(id, name, permissions)
            if (result.isFailure) {
                _error.value = result.exceptionOrNull()?.message ?: "Departman güncellenemedi"
            } else {
                loadDepartments()
            }
            _isLoading.value = false
        }
    }

    fun deleteDepartment(id: String) {
        viewModelScope.launch {
            _isLoading.value = true
            val result = departmentRepository.deleteDepartment(id)
            if (result.isFailure) {
                _error.value = result.exceptionOrNull()?.message ?: "Departman silinemedi"
            } else {
                loadDepartments()
            }
            _isLoading.value = false
        }
    }

    fun clearError() {
        _error.value = null
    }
}

